import { IPartnerFinSobRow } from '../../model/types'

import { RevenueMeasureField } from './types'

/** Sums one measure across rows, keeping "no data" apart from a real zero: `null` when not a single
 *  row carries the column, otherwise the total of the ones that do. */
export const sumMeasure = (
  rows: IPartnerFinSobRow[],
  field: RevenueMeasureField
): number | null => {
  const values = rows.map((row) => row[field]).filter((value): value is number => value !== null)

  if (values.length === 0) {
    return null
  }

  return values.reduce((total, value) => total + value, 0)
}
